// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// =============== Base libraries integration ==================
import Vue from 'vue'
// import VueResource from 'vue-resource'
// // import VueTranslate from 'vue-translate-plugin'

// Vue.use(VueResource)
// Vue.use(VueTranslate)

// import store from './store'
// import router from './router'

// ===== Bootstrap components integration (JQuery needed) ======

// ======================= Base Component ======================
import App from './App'
import VueWaypoint from 'vue-waypoint'
import VueScrollTo from 'vue-scrollto'
import VueLazyload from 'vue-lazyload'

import 'vue-awesome/icons/home'
import 'vue-awesome/icons/address-card'
import 'vue-awesome/icons/handshake-o'
import 'vue-awesome/icons/bar-chart'
import 'vue-awesome/icons/envelope-open'
import 'vue-awesome/icons/image'
import 'vue-awesome/icons/desktop'
import 'vue-awesome/icons/institution'
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/code'
import 'vue-awesome/icons/wordpress'
import 'vue-awesome/icons/spinner'
require('bulma/css/bulma.css')
// import 'vue-awesome/icons'
var Icon = require('vue-awesome/components/Icon.vue')
// import Icon from 'vue-awesome/components/Icon'
Vue.component('icon', Icon)
Vue.component('lazy-component',VueLazyload)
Vue.use(VueLazyload, {
  lazyComponent: true,
  loading: './static/loading.svg'
})
Vue.use(VueScrollTo)
Vue.use(VueWaypoint)
// ======================== Vue Instance =======================
/* eslint-disable no-new */

var root = new Vue({
  // router,
  // store,
  // el: '#app',
  render: h => h(App),
  data: {
    ticking: false,
    particle: null
  },
  mounted () {

    var isMobileD = {
      android: () => navigator.userAgent.match(/Android/i),
      blackberry: () => navigator.userAgent.match(/BlackBerry/i),
      ios: () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
      opera: () => navigator.userAgent.match(/Opera Mini/i),
      windows: () => navigator.userAgent.match(/IEMobile/i),
      any: () => (isMobileD.android() || isMobileD.blackberry() || 
      isMobileD.ios() || isMobileD.opera() || isMobileD.windows())
    }
    isMobileD.any() ? document.body.classList.add('is-touch') : null
    var refdiv = document.createElement('div')
    refdiv.classList.add('bmv-reflection')
    document.querySelector('.bmv-reflection-container').appendChild(refdiv)
    document.querySelector('.bmv-reflection').innerHTML = this.sanitize(document.querySelector('.bmv-reflective').innerHTML)
    window.addEventListener('touchMove', this.requestTick)
    window.addEventListener('touchStart', this.requestTick)
    window.addEventListener('touchEnd', this.requestTick)
    window.addEventListener('scroll', this.requestTick)
    window.addEventListener('resize', this.requestTick)
    window.addEventListener('load',this.bmvUpdateReflection)

    // setInterval(this.bmvUpdateReflection,5)
  },
  methods: {
    requestTick () {
      requestAnimationFrame(this.scrollEvents)
    },
    sanitize(html) {
      return html.replace('id="','id="reflected_')
    },
    scrollEvents() {
      this.bmvUpdateReflection()
    },
    bmvUpdateReflection () {
      try {
        let bmvc = document.querySelector('.bmv-reflection-container')
        let wiggleroom2 = ((parseInt(window.getComputedStyle(document.querySelector('.bmv-reflection')).height) - Math.max(document.documentElement.clientHeight, window.innerHeight || 0)) + parseInt(window.getComputedStyle(document.querySelector('.bmv-reflection-container')).height)) * -1
        if (bmvc.classList.contains('top')) {
          wiggleroom2 = (parseInt(window.getComputedStyle(bmvc).height) * 2)  - parseInt(window.getComputedStyle(document.querySelector('.bmv-reflection')).height)
        } 
        let scrollOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        document.querySelector('.bmv-reflection').style.marginTop = (wiggleroom2 + scrollOffset) + 'px'
      } catch(err) {
        console.log("Reflection error: " + err.message)
      }
    }
  }
})
document.addEventListener('DOMContentLoaded', function () {
  root.$mount('#app')
})


// WEBPACK FOOTER //
// ./src/main.js